import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useTenant } from '../tenancy/TenantProvider'
import { EntryAnimation } from './EntryAnimation'
import { isOnboardingDeferredForSession } from './onboarding-session'

const completedOnboardingStates = new Set(['baseline_complete', 'active', 'offboarding', 'retired'])

export function CustomerEntryRoute() {
  const { current, loading, hasRole, servicePermitted } = useTenant()
  const location = useLocation()

  if (loading) return null
  if (!current) return <Outlet />

  // Service suspension and provisioning restrictions take precedence over onboarding.
  // Keeping the normal shell mounted lets the existing access gate explain the restriction
  // and preserves safe organisation switching without exposing setup as a bypass path.
  if (!servicePermitted) return <Outlet />

  const onboardingComplete = completedOnboardingStates.has(current.organisation.onboardingStatus)
  const canCompleteSetup = hasRole('organisation_admin') || hasRole('governance_manager')
  const onboardingDeferredForSession = isOnboardingDeferredForSession(
    current.organisation.id,
    current.membershipId,
  )

  if (
    !onboardingComplete
    && canCompleteSetup
    && !onboardingDeferredForSession
    && location.pathname !== '/workspace/setup'
  ) {
    return <Navigate to="/workspace/setup" replace />
  }

  if (!onboardingComplete) return <Outlet />

  return (
    <EntryAnimation>
      <Outlet />
    </EntryAnimation>
  )
}
